import React from 'react'
import { noop } from 'lodash-es'
import { CognitoUser } from 'types'
import { Role } from 'libs/api/roles'

export type AuthContextType = {
  currentAuthenticatedUser?: CognitoUser
  setCurrentAuthenticatedUser: (user?: CognitoUser) => void
  challengeUser?: CognitoUser
  setChallengeUser: (challengeUser?: CognitoUser) => void
  resetPasswordUsername?: string
  setResetPasswordUsername: (username: string | undefined) => void
  currentRole?: Role
  setCurrentRole: (role: Role) => void
}

export const AuthContext = React.createContext<AuthContextType>({
  setCurrentAuthenticatedUser: noop,
  setChallengeUser: noop,
  setResetPasswordUsername: noop,
  setCurrentRole: noop,
})

export const AuthCredentialsContext = React.createContext<any>(undefined)

type HealthModeContextType = {
  healthMode: boolean
  setHealthMode: (mode: boolean) => void
}

export const HealthModeContext = React.createContext<HealthModeContextType>({} as never)
